<template>
  <div>
    <top-bar heading="Forms" :buttons="buttons"></top-bar>
    <div class="container-fluid mt-3">
      <b-card header="Forms" no-body>
        <b-card-body>
          <vue-good-table
                  :columns="columns"
                  :rows="forms"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 10,
                    position: 'bottom',
                    perPageDropdown: [10, 25, 50, 100],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                }"
                  :is-loading="loading"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field === 'published'">
                <span class="badge badge-success p-2" v-if="props.row.published">Published</span>
                <span class="badge badge-danger p-2" v-if="!props.row.published">Draft</span>
              </span>
              <span class="text-center" v-else-if="props.column.field === 'form_type'">
                <span class="badge badge-primary p-2 pl-3 pr-3" v-if="props.row.form_type === 1">Assignment</span>
                <span class="badge badge-info p-2 pl-3 pr-3" v-if="props.row.form_type === 2">Learning Activity</span>
                <span class="badge badge-warning p-2 pl-3 pr-3" v-if="props.row.form_type === 3">Signoff Form</span>
                <span class="badge badge-danger p-2 pl-3 pr-3" v-if="props.row.form_type === 5">Document</span>
                <span class="badge badge-success p-2 pl-3 pr-3" v-if="props.row.form_type === 4">Other</span>
              </span>
              <span v-else-if="props.column.field === 'actions'">
                <div class="btn-group">
                  <b-button variant="success" :to="'/forms/' + props.row.id"><font-awesome-icon icon="edit"></font-awesome-icon></b-button>
                  <b-button variant="danger" @click="deleteForm(props.row.id)"><font-awesome-icon icon="trash"></font-awesome-icon></b-button>
                  <b-button variant="warning" @click="cloneForm(props.row.id)"><font-awesome-icon icon="copy"></font-awesome-icon></b-button>
                </div>
              </span>
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
          </vue-good-table>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import findIndex from 'lodash-es/findIndex'

export default {
  name: 'Forms',
  data () {
    return {
      forms: [],
      buttons: [
        {
          label: 'Add New Form',
          click: () => {
            this.axios.post('/forms', { name: 'New Form', type: 1 }).then(rsp => {
              this.$snotify.success('Form Created')
              this.forms.unshift(rsp.data)
            }).catch(err => this.$errorOut(err))
          }
        }
      ],
      columns: [
        {
          field: 'id',
          label: 'ID',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Name',
          field: 'name',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Type',
          field: 'form_type',
          filterOptions: {
            enabled: true,
            filterDropdownItems: [
              { value: 1, text: 'Assignment' },
              { value: 2, text: 'Learning Activity' },
              { value: 3, text: 'Signoff Form' },
              { value: 5, text: 'Document' },
              { value: 4, text: 'Other' }
            ]
          }
        },
        {
          label: 'Published',
          field: 'published',
          filterOptions: {
            enabled: true,
            filterDropdownItems: [
              { value: 0, text: 'Draft' },
              { value: 1, text: 'Published' }
            ]
          }
        },
        {
          label: 'Created',
          field: 'created_at',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Updated',
          field: 'updated_at',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Actions',
          field: 'actions'
        }
      ],
      loading: true
    }
  },
  methods: {
    getForms () {
      this.loading = true
      this.axios.get('/forms', { params: { order_by: 'updated_at,desc' } }).then(rsp => {
        this.forms = rsp.data.data
        this.loading = false
      })
    },
    deleteForm (id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'This will delete the selected form for all students!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.delete('/forms/' + id).then(() => {
            this.$snotify.success('Form Deleted')
            let index = findIndex(this.forms, { id })
            this.forms.splice(index, 1)
          }).catch(err => this.$errorOut(err))
        }
      })
    },
    cloneForm (id) {

      this.$swal({
        title: 'Are you sure?',
        text: 'This clone the form and make a copy of it',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, clone it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.loading = true
          this.axios.get('/forms/' + id + '/clone').then(() => {
            this.getForms();
          }).catch(err => this.$errorOut(err))
        }
      })


    }
  },
  mounted () {
    this.getForms()
  },
  metaInfo: {
    title: 'Forms'
  }
}
</script>
